import { State } from 'ducks/reducers'
import { OrderType } from './types'

// export const getOrder = () => (): OrderType => {
//   const { order } = storeInfo.store.getState()
//   return order
// }

export const getOrder = (state: State): OrderType => state.order
